module.exports = __webpack_public_path__ + "static/media/CovesatNorthvileRidge.d68e324c.pdf";